import React from 'react';
import { motion } from 'framer-motion';
import { Gift, BookOpen, ShieldCheck } from 'lucide-react';
const CHECKOUT_URL = 'https://axe-ia-tech.impultienda.ar/checkout';
export function ValueStack() {
  const items = [{
    icon: <BookOpen className="w-5 h-5 text-blue-600" data-id="element-184" />,
    title: 'Sistema Axe IA Tech',
    description: 'Brief + 50 ángulos',
    value: 'USD 97',
    status: 'INCLUIDO'
  }, {
    icon: <Gift className="w-5 h-5 text-green-500" data-id="element-185" />,
    title: 'Bono #1 · 20 Creativos con IA',
    description: 'Imágenes publicitarias con tu marca',
    value: 'USD 47',
    status: 'GRATIS'
  }, {
    icon: <Gift className="w-5 h-5 text-green-500" data-id="element-186" />,
    title: 'Bono #2 · Biblioteca de Copy',
    description: '100 titulares y 30 estructuras',
    value: 'USD 37',
    status: 'GRATIS'
  }, {
    icon: <Gift className="w-5 h-5 text-green-500" data-id="element-187" />,
    title: 'Bono #3 · Mapa de Segmentación',
    description: 'Públicos, intereses y demografía',
    value: 'USD 27',
    status: 'GRATIS'
  }, {
    icon: <Gift className="w-5 h-5 text-green-500" data-id="element-188" />,
    title: 'Bono #4 · Calculadora ROAS',
    description: 'Simulá cuánto invertir',
    value: 'USD 19',
    status: 'GRATIS'
  }, {
    icon: <Gift className="w-5 h-5 text-green-500" data-id="element-189" />,
    title: 'Bono #5 · Checklist "Campaña en 1 día"',
    description: 'Paso a paso para lanzar',
    value: 'USD 15',
    status: 'GRATIS'
  }, {
    icon: <ShieldCheck className="w-5 h-5 text-blue-500" data-id="element-190" />,
    title: 'Garantía de 7 días',
    description: 'Protección al comprador',
    value: '',
    status: 'INCLUIDA'
  }];
  return <section className="py-20 bg-white" data-id="element-191">
      <div className="max-w-3xl mx-auto px-4" data-id="element-192">
        <div className="text-center mb-12" data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-194">
            📦 TODO LO QUE INCLUYE TU COMPRA
          </h2>
          <p className="text-lg text-slate-600" data-id="element-195">
            Acceso inmediato por un único pago:
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-50 rounded-3xl border border-slate-200 overflow-hidden shadow-sm" data-id="element-196">
          <ul className="divide-y divide-slate-200" data-id="element-197">
            {items.map((item, index) => <li key={index} className="flex items-center gap-4 p-5" data-id="element-198">
                <div className="w-10 h-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center flex-shrink-0" data-id="element-199">
                  {item.icon}
                </div>
                <div className="flex-1 min-w-0" data-id="element-200">
                  <h3 className="font-semibold text-slate-900 text-sm md:text-base" data-id="element-201">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-slate-500" data-id="element-202">
                    {item.description}
                  </p>
                </div>
                <div className="text-right flex flex-col items-end flex-shrink-0" data-id="element-203">
                  {item.value && <span className="text-slate-400 line-through text-xs md:text-sm" data-id="element-204">
                      {item.value}
                    </span>}
                  <span className="text-green-600 font-bold text-xs md:text-sm" data-id="element-205">
                    {item.status}
                  </span>
                </div>
              </li>)}
          </ul>

          <div className="bg-blue-600 text-white p-6 md:p-8 text-center" data-id="element-206">
            <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4 mb-1" data-id="element-207">
              <span className="text-blue-200 line-through text-lg" data-id="element-208">
                Valor total regular: USD 242
              </span>
              <span className="text-3xl md:text-4xl font-black" data-id="element-209">
                Hoy: USD 17
              </span>
            </div>
            <p className="text-blue-100 text-sm" data-id="element-210">
              Precio único · Acceso de por vida
            </p>
            <p className="text-blue-100 text-sm mt-1" data-id="element-211">
              Pagá en tu moneda local
            </p>
          </div>
        </motion.div>

        <div className="text-center mt-8" data-id="element-212">
          <motion.a href={CHECKOUT_URL} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full md:w-auto px-12 bg-gradient-to-r from-blue-700 to-indigo-700 text-white text-center font-bold text-lg py-4 rounded-xl shadow-lg shadow-blue-500/30 hover:from-blue-800 hover:to-indigo-800 transition-all" data-id="element-213">
            COMPRAR AHORA Y ACTIVAR ACCESO
          </motion.a>

          <div className="text-green-600 font-bold mt-4" data-id="element-214">
            Ahorrás USD 225 (93% OFF)
          </div>

          <div className="flex items-center justify-center gap-2 text-sm text-slate-500 mt-3" data-id="element-215">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-216" />
            Garantía de devolución de 7 días · Compra 100% segura
          </div>
        </div>
      </div>
    </section>;
}